import { createContext } from 'react';
import type { RuntimeConfig } from './runtimeConfig';

export const RuntimeConfigContext = createContext<RuntimeConfig | null>(null);
